'use client';

import { c as _c } from "react/compiler-runtime";
import { styled } from '@classify/react-core-components/styles';
import { Radio } from '@mui/material';
import Skeleton from '@classify/react-core-components/Skeleton';
import Typography from '@classify/react-core-components/Typography';
import { translate } from '@openclassrooms/translations';
const Root = styled('div')(({
  theme: {
    spacing
  }
}) => ({
  margin: spacing(5, 0),
  height: '100%'
}));
const SkeletonContent = styled('div')(({
  theme: {
    spacing,
    palette
  }
}) => ({
  maskImage: 'linear-gradient(to bottom, black 30%, transparent 130%)',
  padding: spacing(5),
  border: `1px solid ${palette.layout.surface.border}`,
  borderBottom: 'none',
  borderTopRightRadius: '4px',
  borderTopLeftRadius: '4px'
}));
const QuestionSkeleton = styled(Skeleton)(({
  theme: {
    spacing
  }
}) => ({
  display: 'block',
  height: 32,
  width: '90%',
  marginTop: spacing(2)
}));
const AnswerRow = styled('div')(({
  theme: {
    spacing
  }
}) => ({
  display: 'flex',
  alignItems: 'center',
  marginTop: spacing(2)
}));
const AnswerSkeleton = styled(Skeleton)({
  display: 'block'
});
const SkeletonWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column'
});
const Title = styled(Typography)(({
  theme: {
    spacing,
    palette
  }
}) => ({
  width: '100%',
  borderBottom: `1px solid ${(palette as any).line || palette.divider}`,
  paddingBottom: spacing(1),
  '&:not(:first-of-type)': {
    marginTop: spacing(2)
  }
}));
const QuizSkeleton = () => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [150, 150, 100, 70];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const answerSkeletonsWidth = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Title variant="h4">{translate("quizpage.not_logged.skeleton.question_1")}</Title>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <SkeletonWrapper><QuestionSkeleton />{answerSkeletonsWidth.map(_temp)}</SkeletonWrapper>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Root aria-hidden="true"><SkeletonContent>{t1}{t2}<Title variant="h4">{translate("quizpage.not_logged.skeleton.question_2")}</Title></SkeletonContent></Root>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
export default QuizSkeleton;
function _temp(width, index) {
  return <AnswerRow key={index}><Radio disabled={true} disableFocusRipple={true} /><AnswerSkeleton width={width} height={32} /></AnswerRow>;
}